import React, { createContext, useContext, useState } from "react";
import axios from "axios";
import { urls } from "../services/apiService";

const PredictedYieldContext = createContext();

export const PredictedYieldProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);



  const fetchPredictedYield = async (requestData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(urls.yield, requestData);
      setData(response.data);
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PredictedYieldContext.Provider value={{ data, error, loading, fetchPredictedYield }}>
      {children}
    </PredictedYieldContext.Provider>
  );
};

export const usePredictedYield = () => {
  const context = useContext(PredictedYieldContext);
  if (!context) {
    throw new Error("usePredictedYield must be used within a PredictedYieldProvider");
  }
  return context;
};
